import type { Theme } from '@mui/material';

const SIZE_IN_PIXELS = { small: 24, medium: 40, large: 56 } as const;
const FONT_SIZE_RATIO = 0.5;

type AvatarSize = keyof typeof SIZE_IN_PIXELS;

function sizeStyles(pixels: number) {
  return {
    width: pixels,
    height: pixels,
    fontSize: (theme: Theme) => theme.typography.pxToRem(pixels * FONT_SIZE_RATIO),
  };
}

export const AVATAR_SIZES = {
  small: sizeStyles(SIZE_IN_PIXELS.small),
  medium: sizeStyles(SIZE_IN_PIXELS.medium),
  large: sizeStyles(SIZE_IN_PIXELS.large),
};

export type { AvatarSize };
